export default __webpack_public_path__ + "static/media/notification-icon.36442b89.svg";